import { render, staticRenderFns } from "./AvalView.vue?vue&type=template&id=a5f52828"
import script from "./AvalView.vue?vue&type=script&lang=js"
export * from "./AvalView.vue?vue&type=script&lang=js"
import style0 from "./AvalView.vue?vue&type=style&index=0&id=a5f52828&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports